import moment from "moment";
import { map, isEmpty, has, get, xorWith, isEqual, includes } from "lodash";
import Compressor from "compressorjs";
import genericAction from "@Actions/generic";
import store from "@Redux";
import downloadFile from "@Redux/Actions/downloads";

export const getObjectURL = async (fileOrUrl) => {
	if (typeof fileOrUrl === "string") {
		return store.dispatch(downloadFile({ uri: fileOrUrl }));
	}
	return URL.createObjectURL(fileOrUrl);
};

export const convertImageToBase64 = async (imageUrl) => {
	const response = await fetch(imageUrl);
	const blob = await response.blob();

	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			return resolve(reader.result);
		};
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
};

export const buildAuthPath = (type, companyName, token) => {
	return `${type}${companyName ? `/${companyName}` : ""}${token ? `/${token}` : ""}`;
};

export const isArrayEqual = (x, y) => {
	return isEmpty(xorWith(x, y, isEqual));
};

export const getExcludingNulls = (object, path, defaultValue) => {
	const temp = get(object, path, defaultValue);
	return temp === null ? defaultValue : temp;
};

export const dataHandler = async ({ dispatch, url, params }) => {
	const urlParams = new URLSearchParams(params).toString();
	const data = await dispatch(genericAction({ method: "get", route: `${url}?${urlParams}` }));
	if (isEmpty(data)) return [];
	return data;
};

export const buildURLQuery = (obj) => {
	Object.entries(obj)
		.map((pair) => {
			return pair.map(encodeURIComponent).join("=");
		})
		.join("&");
};

export const getTimeStamp = () => {
	return moment().valueOf();
};

export const getTimeLabel = (time, format) => {
	if (time) {
		return moment(time).format(format);
	}
	return "";
};

export const getValidationErrors = (validation, defaultErrors) => {
	const { details } = validation.error;
	let errors = defaultErrors;
	map(details, (item) => {
		errors = { ...errors, [item.context.key]: item.message };
	});
	return errors;
};

export const stateSetter = (namedData, dataInput, setFunctions, clearErrors) => {
	let dataToSet = namedData;
	let errorToClear = "";
	if (!isEmpty(dataInput)) {
		const { name, value } = dataInput;
		errorToClear = name;
		dataToSet = { [name]: value };
	}

	if (!isEmpty(clearErrors) && !isEmpty(errorToClear)) {
		const { errors, setErrors } = clearErrors;
		setErrors({ ...errors, [errorToClear]: "" });
	}

	const dataToSetKeys = Object.keys(dataToSet);
	if (dataToSetKeys.length === 1) {
		const key = dataToSetKeys[0];
		const setFunction = setFunctions[key];
		setFunction(dataToSet[key]);
	} else {
		for (const key in dataToSet) {
			if (has(dataToSet, key) && has(setFunctions, key)) {
				const setFunction = setFunctions[key];
				setFunction(dataToSet[key]);
			}
		}
	}
};

export function compressImage(image) {
	return new Promise((resolve, reject) => {
		new Compressor(image, {
			quality: 0.6,
			maxHeight: 1024,
			maxWidth: 1024,
			success(result) {
				resolve(result);
			},
			error() {
				reject("Error Comprimiendo Imagen");
			},
		});
	});
}

export function dropdownFormat(data, label, value, defaultLabel = "", defaultValue = "") {
	const formatData = map(data, (item, index) => {
		return { key: index + 1, text: get(item, label, defaultLabel), value: get(item, value, defaultValue) };
	});
	return formatData;
}

export const colorGenerator = () => {
	const letters = "0123456789ABCDEF".split("");
	let color = "#";
	for (let i = 0; i < 6; i += 1) {
		color += letters[Math.floor(Math.random() * 16)];
	}
	return color;
};

export const dateSort = (a, b) => {
	const dateA = new Date(a);
	const dateB = new Date(b);
	return dateA - dateB;
};

export const multiIncludes = (text, values) => {
	return values.some((val) => {
		return text.includes(val);
	});
};

export const truncateText = (string, size) => {
	const validString = multiIncludes(string, ["\n", "\r", "\t"]) ? string.split("\n")[0] : string;
	if (validString.length > size) {
		return `${validString.slice(0, size - 1)}...`;
	}
	return validString;
};

export const sanitizeMessageForPersist = (message) => {
	const { fileUri, ...rest } = message;
	return rest;
};

export const sanitizeMessagesForPersist = (messages) => {
	return map(messages, sanitizeMessageForPersist);
};

export const isRemoteMediaUri = (uri) => {
	if (!uri || typeof uri !== "string") return false;
	return !includes(uri, "localhost") && !uri.startsWith("blob:") && !uri.startsWith("file:");
};

export const canViewChat = ({ chatUserId, chatGroupId }) => {
	const { permissions, groups, userId } = store.getState().user;
	const mappedGroups = map(groups, (item) => {
		return item.id;
	});
	const viewByUser = chatUserId === userId || (!chatUserId && (includes(mappedGroups, chatGroupId) || !chatGroupId));
	return permissions.allowViewAllChats || viewByUser;
};
